export default __webpack_public_path__ + "static/media/image-study-board-1-w@2x.d2b12313.webp";